// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"styles_spinnerContainer__2T17F"};